export default "__VITE_ASSET__6997dbb3__"